import {Component, Input} from '@angular/core';
import {ChipModule} from "primeng/chip";
import {PipesModule} from "../../../../core/pipes/pipes.module";
import {ButtonDirective} from "primeng/button";
import {Router, RouterLink} from "@angular/router";
import {CardModule} from "primeng/card";
import {SkeletonModule} from "primeng/skeleton";
import {FeedApiModel} from "../../../../api/models/feed.api.model";
import {DatePipe, NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {MediaObjectInterface} from "../../../../core/interfaces/media-object.interface";
import {EndCapModule} from "../../../../shared/end-cap/end-cap.module";
import {TranslateModule} from "@ngx-translate/core";
import {AbstractComponent} from "../../../../core/components/abstract-component";
import {TruncateOnWordPipe} from "../../../../core/pipes/truncate-on-word.pipe";
import {AspectRatioDirective} from "../../../../core/directives/aspect-ratio.directive";
import {QrDialogComponent, QrDialogData} from "../../../../shared/qr/qr-dialog.component";
import {PublicResourceUrlService} from "../../../../shared/services/public-resource-url.service";

@Component({
  selector: 'app-feed-card',
  standalone: true,
  imports: [
    ChipModule,
    PipesModule,
    ButtonDirective,
    RouterLink,
    CardModule,
    SkeletonModule,
    DatePipe,
    NgIf,
    NgForOf,
    EndCapModule,
    TranslateModule,
    NgOptimizedImage,
    AspectRatioDirective,
    QrDialogComponent
  ],
  templateUrl: './feed-card.component.html',
  styleUrl: './feed-card.component.scss'
})
export class FeedCardComponent extends AbstractComponent {
  get cover(): MediaObjectInterface {
    return this.feed.cover as MediaObjectInterface;
  }

  @Input() public feed: FeedApiModel;
  @Input() public mode: 'list' | 'grid' | 'show';
  @Input() public lcpPriority = false;
  /** Keeps swipe-preview card geometry without starting its cover/avatar downloads. */
  @Input() public mediaDeferred = false;
  public qrDialogVisible = false;
  public qrDialogData: QrDialogData | null = null;

  constructor(
    private readonly router: Router,
    private readonly publicResourceUrlService: PublicResourceUrlService
  ) {
    super();
  }

  public openQrDialog(): void {
    this.qrDialogData = {
      resourceType: 'feed',
      title: this.feed.heading,
      subtitle: TruncateOnWordPipe.truncateOnWord(this.feed.content, 255, '...'),
      url: this.getFeedUrl()
    };
    this.qrDialogVisible = true;
  }

  getFeedUrl(): string {
    return this.publicResourceUrlService.getFeedUrl(this.feed.slug);
  }
}
